<template>
  <div class="main">
    <div>
      <van-dropdown-menu v-if="shopInfo.isSubAccount != 'T'">
        <van-dropdown-item
          @change="loadMembers"
          v-model="accountSelect"
          :options="accountOptions"
        />
      </van-dropdown-menu>
    </div>
    <van-search
      v-model="keyword"
      show-action
      placeholder="搜索姓名、昵称、手机号"
      @click="goMenberSearch"
    >
      <template #action>
        <div @click="goMenberSearch">搜索</div>
      </template>
    </van-search>
    <van-tabs
      :active="activeTabsValue"
      @click="changeTabs"
      :ellipsis="false"
      sticky
      color="#C59770"
      title-active-color="#C59770"
    >
      <van-tab name="全部会员" title="全部会员">
        <div class="addTime-container">
          <div class="time">注册时间</div>
          <div class="condition" @click="handleNewTime">
            <span>{{ newTimeText }}</span>
            <van-icon
              class="play"
              :class="{ handlePlay: newTimeIcon }"
              name="play"
            />
          </div>
        </div>
        <div class="members">
          <van-empty v-if="!members.data.length" description="没有数据" />
          <div v-else class="vipLise">
            <menberListCard
              v-for="(item, idx) in members.data"
              v-bind:key="idx"
              :item="item"
              toLink=""
            />
          </div>
        </div>
      </van-tab>
      <van-tab name="注册会员" title="注册会员" style="white-space: nowrap">
        <div class="register-container">
          <div class="time-sort">
            <div class="register-time">
              <div class="select-time" @click="showSelectDate('reg')">
                <span>{{
                  this.dataVale.register.value
                    ? this.dataVale.register.value + "月"
                    : "选择时间"
                }}</span>
                <van-icon name="arrow-down" />
              </div>
              <div class="time">注册时间</div>
              <div class="condition" @click="handleRegisterText">
                <span>{{ register.text }}</span>
                <van-icon
                  class="play"
                  :class="{ handlePlay: registerIcon }"
                  name="play"
                />
              </div>
            </div>
          </div>
          <div class="count">共{{ registerData.totalCount }}个</div>
        </div>
        <div class="members">
          <van-empty v-if="!registerData.data.length" description="没有数据" />
          <div v-else class="vipLise">
            <menberListCard
              v-for="(item, idx) in registerData.data"
              v-bind:key="idx"
              :item="item"
            />
          </div>
        </div>
      </van-tab>
      <van-tab name="成交会员" title="成交会员">
        <div class="make-container">
          <div class="select-time" @click="showSelectDate('cg')">
            <span>{{
              this.dataVale.make.value
                ? this.dataVale.make.value + "月"
                : "选择时间"
            }}</span>
            <van-icon name="arrow-down" />
          </div>
          <div class="center">
            <span class="sum">成交单数:</span>
            <span>{{ makeData.totalCount }}</span>
          </div>
          <div class="right">总计:￥{{ makeData.totalMoney }}</div>
        </div>
        <van-empty v-if="!makeData.data.length" description="没有数据" />
        <div v-else class="members">
          <div class="vipLise">
            <menberListMake
              v-for="(item, index) in makeData.data"
              :key="index"
              :item="item"
            />
          </div>
        </div>
      </van-tab>
      <van-tab name="有储值卡会员" title="有储值卡会员">
        <div class="addTime-container">
          <div class="time">注册时间</div>
          <div class="condition" @click="handleHaveNewTime">
            <span>{{ haveNewTimeText }}</span>
            <van-icon
              class="play"
              :class="{ handlePlay: haveNewTimeIcon }"
              name="play"
            />
          </div>
        </div>
        <van-empty v-if="!haveData.data.length" description="没有数据" />
        <div v-else class="members">
          <div class="vipLise">
            <menberListCard
              v-for="(item, index) in haveData.data"
              :key="index"
              :item="item"
              toLink=""
            />
          </div>
        </div>
      </van-tab>
      <van-tab name="访客" title="访客">
        <div class="visitor-container">
          <div class="select-time" @click="showSelectDate('fk')">
            <span>{{
              this.dataVale.visitor.value
                ? this.dataVale.visitor.value + "月"
                : "选择时间"
            }}</span>
            <van-icon name="arrow-down" />
          </div>
          <div class="condition">
            <div class="count">次数</div>
            <div class="select" @click="handleVisitor">
              <span>{{ visitorText }}</span>
              <van-icon
                class="play"
                :class="{ handlePlay: visitorIcon }"
                name="play"
              />
            </div>
          </div>
        </div>
        <van-empty v-if="!visitorData.data.length" description="没有数据" />
        <div v-else class="members">
          <div class="vipLise">
            <menberListFk
              v-for="(item, index) in visitorData.data"
              :key="index"
              :item="item"
              toLink=""
            />
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <!-- 时间选择器 -->
    <van-popup v-model="selectDate.show" position="bottom">
      <van-datetime-picker
        v-model="selectDate.currentDate"
        type="year-month"
        title="选择年月"
        :formatter="selectDate.formatter"
        @confirm="handleSelectDate"
        @cancel="
          () => {
            this.selectDate.show = false;
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import "../../assets/css/member/memberList.less";
import { apiPost } from "@/api/common";
import menberListCard from "./menberCard";
import menberListMake from "./memberMake";
import menberListFk from "./menberFk";
// 引入vant组件库
export default {
  name: "MemberList",
  data() {
    return {
      shopInfo: "", //用户信息
      nemberOverview: "",
      accountSelect: "0",
      accountOptions: [{ text: "选择账号", value: "0" }],
      finished: false,
      members: {
        //全部会员列表
        data: [],
        pageNum: 1,
        pageSize: 10,
        totalCount: 0,
      },
      registerData: {
        //注册会员列表
        data: [],
        pageNum: 1,
        pageSize: 10,
        totalCount: 0,
      },
      makeData: {
        //成交会员列表
        data: [],
        pageNum: 1,
        pageSize: 10,
        totalCount: 0,
        totalMoney: 0,
      },
      haveData: {
        data: [],
        pageNum: 1,
        pageSize: 10,
        totalCount: 0,
      }, //储值卡会员列表
      visitorData: {
        data: [],
        pageNum: 1,
        pageSize: 10,
        totalCount: 0,
      }, //访客会员列表
      keyword: "",
      //新增时间
      newTimeText: "倒序",
      //注册时间
      register: {
        text: "倒序",
      },
      registerList: [],
      //有储值卡===注册时间
      haveNewTimeText: "倒序",
      //访客
      visitorText: "倒序",
      //时间选择器
      selectDate: {
        currentDate: new Date(),
        show: false,
        type: "",
        regValue: "", //注册时间筛选
        chenjiaoValue: "", //成交时间
        fangkeValue: "", //访客时间
      },
      //有所时筛选间选择的值
      dataVale: {
        register: {
          value: "",
          startTime: "",
          endTime: "",
        }, //注册会员
        make: {
          value: "",
          startTime: "",
          endTime: "",
        }, //成交会员
        visitor: {
          value: "",
          startTime: "",
          endTime: "",
        }, //访客
      },
      //记录当前激活的tabs
      activeTabsValue: "全部会员",
    };
  },
  computed: {
    newTimeIcon() {
      return this.newTimeText === "倒序";
    },
    registerIcon() {
      return this.register.text === "倒序";
    },
    haveNewTimeIcon() {
      return this.haveNewTimeText === "倒序";
    },
    visitorIcon() {
      return this.visitorText === "倒序";
    },
  },
  components: {
    menberListCard,
    menberListMake,
    menberListFk,
  },
  created() {
    this.loadComments();
    this.loadData();
  },
  methods: {
    loadComments() {
      let s = sessionStorage.getItem("shopInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
    },
    formatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      return val;
    },
    loadData() {
      // this.loadMemberOverview();
      this.loadSubaccounts();
      this.loadMembers();
    },
    //查询店铺子账号
    loadSubaccounts() {
      const _this = this;
      const data = {
        accountId: this.shopInfo.id,
        shopCode: this.shopInfo.shopCode,
      };
      apiPost("/api/storeSubbranch/querySubAccountList", data).then((resp) => {
        let _data = resp.data;
        if (_data.code == "0000") {
          let subAccounts = _data.data.results;
          for (let i = 0; i < subAccounts.length; i++) {
            let item = {
              text: subAccounts[i].userName,
              value: subAccounts[i].id + "",
            };
            _this.accountOptions.push(item);
          }
        } else {
          _this.$toast.fail(_data.msg);
        }
      });
    },
    //跳转到注册页面
    onSearch() {
      this.$router.push("/registerMember");
    },
    //全部会员
    handleNewTime() {
      this.newTimeText === "正序"
        ? (this.newTimeText = "倒序")
        : (this.newTimeText = "正序");
      this.loadMembers();
    },
    //注册时间
    handleRegisterText() {
      this.register.text === "正序"
        ? (this.register.text = "倒序")
        : (this.register.text = "正序");
      this.seachRegister();
    },
    //有储值卡===注册时间
    handleHaveNewTime() {
      this.haveNewTimeText === "正序"
        ? (this.haveNewTimeText = "倒序")
        : (this.haveNewTimeText = "正序");
      this.searchStuck();
    },
    handleVisitor() {
      this.visitorText === "正序"
        ? (this.visitorText = "倒序")
        : (this.visitorText = "正序");
      this.searchVisitor();
    },
    //显示时间选择器
    showSelectDate(type) {
      this.selectDate.show = true;
      this.selectDate.type = type;
    },

    
    //============查询========================================

    //加载会员查询信息
    loadMembers() {
      this.activeTabsValue = "全部会员";
      const _this = this;
      const url = "/mem/member/query";
      let isSubAccount = this.shopInfo.isSubAccount;
      let account = "";
      let shopId = this.shopInfo.id;
      if (this.accountSelect == 0) {
        isSubAccount = isSubAccount ? isSubAccount : "F";
      } else {
        isSubAccount = "T";
        account = this.accountSelect;
      }
      let data = {
        account: account,
        isSubAccount: isSubAccount,
        shopCode: this.shopInfo.shopCode,
        shopId: shopId,
        day: this.dateSelect,
        sort: this.newTimeIcon ? "DESC" : "ASC",
        memberType: "register",
      };
      apiPost(url, data).then((resp) => {
        let _data = resp.data;
        if (_data.code == "0000") {
          let members = _data.data.results.mbrInfoQueryVoList;
          for (let i = 0; i < members.length; i++) {
            let time = members[i].createTime + "";
            members[i].createTime = time.substring(0, 10);
          }
          _this.members.data = Object.freeze(members);
        } else {
          _this.$toast.fail(_data.msg);
        }
      });
    },
    //注册数据
    seachRegister() {
      /**
       * account
       * isSubAccount
       * memberType
       */
      const _this = this;
      const data = {
        isSubAccount: _this.isSubAccount ? _this.isSubAccount : "F",
        memberType: "register",
        shopCode: _this.shopInfo.shopCode,
        startTimeStart: this.dataVale.register.startTime,
        startTimeEnd: this.dataVale.register.endTime,
        sort: this.registerIcon ? "DESC" : "ASC",
      };
      this.shopInfo.isSubAccount ? "" : (data.shopId = this.shopInfo.id);
      this.shopInfo.isSubAccount ? (data.account = this.shopInfo.id) : "";
      this.$http.post("/mem/member/query", data).then((res) => {
        if (res.data.code === "0000") {
          _this.registerData.data = Object.freeze(
            res.data.data.results.mbrInfoQueryVoList
          );
          _this.registerData.totalCount =
            res.data.data.results.totalRegisteredNum;
        }
        return;
      });
    },
    //会员数据
    searchMake() {
      const _this = this;
      const data = {
        isSubAccount: _this.isSubAccount ? _this.isSubAccount : "F",
        queryType: "2",
        shopCode: _this.shopInfo.shopCode,
        startTimeStart: this.dataVale.make.startTime,
        startTimeEnd: this.dataVale.make.endTime,
      };
      this.shopInfo.isSubAccount ? "" : (data.shopId = this.shopInfo.id);
      this.shopInfo.isSubAccount ? (data.account = this.shopInfo.id) : "";
      this.$http.post("/mem/member/query", data).then((res) => {
        if (res.data.code === "0000") {
          _this.makeData.data = Object.freeze(
            res.data.data.results.mbrInfoQueryVoList
          );
          _this.makeData.totalCount = res.data.data.results.totalDealNum;
          _this.makeData.totalMoney = res.data.data.results.totalMoney;
        }
      });
    },
    //有卡数据
    searchStuck() {
      const _this = this;
      const data = {
        isSubAccount: _this.isSubAccount ? _this.isSubAccount : "F",
        queryType: "3",
        shopCode: _this.shopInfo.shopCode,
        sort: this.haveNewTimeIcon ? "DESC" : "ASC",
      };
      this.shopInfo.isSubAccount ? "" : (data.shopId = this.shopInfo.id);
      this.shopInfo.isSubAccount ? (data.account = this.shopInfo.id) : "";
      this.$http.post("/mem/member/query", data).then((res) => {
        if (res.data.code === "0000") {
          _this.haveData.data = Object.freeze(res.data.data.results);
        }
      });
    },
    //访客数据
    searchVisitor() {
      const _this = this;
      const data = {
        isSubAccount: _this.isSubAccount ? _this.isSubAccount : "F",
        queryType: "3",
        shopCode: _this.shopInfo.shopCode,
        startTimeStart: this.dataVale.visitor.startTime,
        startTimeEnd: this.dataVale.visitor.endTime,
        sort: this.visitorIcon ? "DESC" : "ASC",
      };
      this.shopInfo.isSubAccount ? "" : (data.shopId = this.shopInfo.id);
      this.shopInfo.isSubAccount ? (data.account = this.shopInfo.id) : "";
      this.$http.post("/mem/member/query", data).then((res) => {
        if (res.data.code === "0000") {
          _this.visitorData.data = Object.freeze(res.data.data.results);
        }
      });
    },
    //===========================================================
    //时间选择确定
    handleSelectDate(date) {
      //toLocaleDateString
      let selectDate = new Date(date);
      const month = selectDate.getMonth();
      selectDate.setDate(1);
      const startTime = selectDate.toLocaleDateString().replace(/\//g, "-");
      selectDate.setMonth(month + 1);
      selectDate = new Date(selectDate.getTime() - 1000);
      const endTime = selectDate.toLocaleDateString().replace(/\//g, "-");
      switch (this.selectDate.type) {
        case "reg":
          if (new Date().getFullYear() === selectDate.getFullYear()) {
            this.dataVale.register.value = month + 1;
          } else {
            this.dataVale.register.value =
              selectDate.getFullYear() + "年" + (month + 1);
          }
          this.dataVale.register.startTime = startTime;
          this.dataVale.register.endTime = endTime;
          this.seachRegister();
          break;
        case "cg":
          if (new Date().getFullYear() === selectDate.getFullYear()) {
            this.dataVale.make.value = month + 1;
          } else {
            this.dataVale.make.value =
              selectDate.getFullYear() + "年" + (month + 1);
          }
          this.dataVale.make.startTime = startTime;
          this.dataVale.make.endTime = endTime;
          this.searchMake();
          break;
        case "fk":
          if (new Date().getFullYear() === selectDate.getFullYear()) {
            this.dataVale.visitor.value = month + 1;
          } else {
            this.dataVale.visitor.value =
              selectDate.getFullYear() + "年" + (month + 1);
          }
          this.dataVale.visitor.startTime = startTime;
          this.dataVale.visitor.endTime = endTime;
          this.searchVisitor();
          break;
        default:
          break;
      }

      this.selectDate.show = false;
    },
    //tabs-click
    changeTabs(name, title) {
      if (this.activeTabsValue === title) return;
      this.activeTabsValue = title;
      switch (title) {
        case "全部会员":
          this.loadMembers();
          break;
        case "注册会员":
          this.seachRegister();
          break;
        case "成交会员":
          this.searchMake();
          break;
        case "有储值卡会员":
          this.searchStuck();
          break;
        case "访客":
          this.searchVisitor();
          break;
        default:
          break;
      }
    },
    //跳转搜索页
    goMenberSearch() {
      this.$router.push({
        name: "MemberSearch",
        query: {
          ...this.shopInfo,
        },
      });
    },
  },
};
</script>


